export namespace LegalContactConstants {
    export const ADDITIONAL_FIELD_PREFIX = "additionalFields:";

    // Pagination constants for export operations
    export const EXPORT_PAGE_SIZE = 500;
    export const EXPORT_MAX_PAGES = 100;

    export const FIELD_KEY_TO_PROPERTY: Record<string, string> = {
        "legalContactUser": "legalContactUser",
        "legalScopes": "legalScopeOptions",
        "legalTeams": "legalTeamOptions",
        "legalSubTeams": "legalSubTeamOptions",
        "manager": "legalContactManager",
        "officeLocation": "legalContactOfficeLocation",
        "businessLeader": "businessLeader"
    };
}
